import { render, staticRenderFns } from "./header-checkout.vue?vue&type=template&id=5f94da55&"
import script from "./header-checkout.vue.ts?vue&type=script&lang=ts&"
export * from "./header-checkout.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports